// extracted by mini-css-extract-plugin
export default {"hideTooltip":"u8-z","fadeIn":"v8-z","delay":"w8-z","recommendedSizeTooltip":"x8-z"};